import { PropsWithChildren, FC } from 'react'
import { Input } from 'antd'

const InputGroup = Input.Group

interface RangeFilterPropsType {
    handleRangeFilter: (
        filterType: string,
        sliderValues: (string | number)[],
    ) => void
    filterType: string
    selectedValues?: (string | number)[]
}

const DrawerRange: FC<PropsWithChildren<RangeFilterPropsType>> = props => {
    const { handleRangeFilter, filterType, selectedValues } = props
    const [selectedLowerValue, selectedUpperValue] = selectedValues || []

    const onChangeValue = (rangeValue: string, type: string) => {
        const numericValue = rangeValue.replace(/[^\d,]/g, '')
        const valueArray =
            type === 'min'
                ? [numericValue, selectedUpperValue || '0']
                : [selectedLowerValue || '0', numericValue]

        handleRangeFilter(filterType, valueArray)
    }

    return (
        <InputGroup compact>
            <Input
                addonBefore="Between"
                style={{ width: '192px', textAlign: 'center', borderRight: 0 }}
                placeholder="Minimum"
                value={selectedLowerValue}
                onChange={evt => onChangeValue(evt.target.value, 'min')}
            />
            <Input
                style={{
                    width: 30,
                    borderLeft: 0,
                    pointerEvents: 'none',
                    backgroundColor: '#fff',
                }}
                placeholder="~"
                disabled
            />
            <Input
                style={{ width: '104px', textAlign: 'center', borderLeft: 0 }}
                placeholder="Maximum"
                value={selectedUpperValue}
                onChange={evt => onChangeValue(evt.target.value, 'max')}
            />
        </InputGroup>
    )
}

export default DrawerRange
